import type { ReactNode } from "react";

type ReportPeriodStatusBadgeProps = {
  className?: string;
  icon?: ReactNode;
  label: ReactNode;
};

const ReportPeriodStatusBadge = ({
  className,
  icon,
  label,
}: ReportPeriodStatusBadgeProps) => (
  <span
    className={["cle-report-detail__reported-status", className]
      .filter(Boolean)
      .join(" ")}
  >
    {icon}
    {label}
  </span>
);

export default ReportPeriodStatusBadge;
